import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  useGetVerificationStatusSource,
  useSubmitVerificationSource,
} from 'hooks/useGetVerificationStatus';
import {
  SubmitVerificationInfo,
  VerificationStatusResponse,
} from 'types/verification';
import verificationStatus from '../../../../data/verificationStatus';
import { SourceOfFundsState } from './SourceOfFundsState';
import { SourceOfFundsTypes } from './SourceOfFundsTypes';
import SourceOfFundsView from './components/SourceOfFundsView';

export const Route = createFileRoute('/_authenticated/verification/source-of-funds')({
  component: SourceOfFunds,
});

function SourceOfFunds() {
  const responses: VerificationStatusResponse[] = [];
  const [submitVerificationSource] = useSubmitVerificationSource();
  const sourceInfo = useGetVerificationStatusSource();
  const navigate = useNavigate();

  function addCallback(response: VerificationStatusResponse) {
    responses.push(response);
  }

  async function submitForm(viewState: SourceOfFundsState) {
    const request: SubmitVerificationInfo = {
      fields: [],
      callback: addCallback,
    };

    sourceInfo?.requiredSubmissionFields?.forEach(field => {
      request.fields.push({ key: field, value: viewState.source });
    });

    await submitVerificationSource(request);
    const temp = viewState.source as SourceOfFundsTypes;

    if (
      responses.filter(
        x =>
          x.statusCode !== verificationStatus.PendingAttachment &&
          x.statusCode !== verificationStatus.Verified,
      ).length === 0
    )
      navigate({ to: '/verification/id-verification' });
  }

  return <SourceOfFundsView sourceInfo={sourceInfo} onComplete={submitForm} />;
}

export default SourceOfFunds;
